import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'

interface FAQItemProps {
  number: number
  question: string
  answer: string
}

function FAQItem({ number, question, answer }: FAQItemProps) {
  return (
    <div className="group flex gap-6 py-6">
      {/* Number */}
      <div
        className={cn(
          'flex-shrink-0 text-2xl font-bold text-accent',
          'w-12 transition-transform duration-200 ease-out',
          'group-hover:scale-110'
        )}
      >
        {String(number).padStart(2, '0')}
      </div>

      {/* Content */}
      <div className="flex-1">
        <h3 className="text-lg font-semibold text-foreground">
          {question}
        </h3>
        <p className="mt-2 text-foreground-muted">
          {answer}
        </p>
      </div>
    </div>
  )
}

/**
 * FAQ section with numbered list
 * Implementation: LAND2-005
 */
export function FAQSection() {
  const { t } = useTranslation()

  const faqs = [
    { question: t('landing.faq.q1.title'), answer: t('landing.faq.q1.answer') },
    { question: t('landing.faq.q2.title'), answer: t('landing.faq.q2.answer') },
    { question: t('landing.faq.q3.title'), answer: t('landing.faq.q3.answer') },
    { question: t('landing.faq.q4.title'), answer: t('landing.faq.q4.answer') },
    { question: t('landing.faq.q5.title'), answer: t('landing.faq.q5.answer') },
    { question: t('landing.faq.q6.title'), answer: t('landing.faq.q6.answer') },
    { question: t('landing.faq.q7.title'), answer: t('landing.faq.q7.answer') },
  ]

  return (
    <div className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <h2 className="text-center text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
          {t('landing.faq.title')}
        </h2>

        {/* FAQ List */}
        <div className="mt-12 divide-y divide-border lg:mt-16">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              number={index + 1}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
